<template>
  <footer class="footer">
    <div class="copyright">
      <a
        class="wkLogo"
        :href="FOOTER_LINKS.WK_LOGO"
        target="_blank" />
      <div class="copyrightFull">© 2022 UpToDate, Inc. and/or its affiliates. All Rights Reserved.</div>
    </div>
    <div
      id="tier1"
      class="tiers">
      <div>
        <a
          id="termsOfUse"
          :href="FOOTER_LINKS.TERMS_OF_USE"
          target="_blank">Terms of Use</a>
        <a 
          id="ot-sdk-btn"
          class="ot-sdk-show-settings manageCookiePreferences">Manage Cookie Preferences</a>
        <a
          id="policies"
          :href="FOOTER_LINKS.POLICIES"
          target="_blank">Policies</a>
        <console-button
          v-if="showSupportTag"
          id="supportTag"
          href=""
          @on-click="onClick()">Support Tag</console-button>
      </div>
      <div class="socials">
        <a
          id="facebook"
          :href="FOOTER_LINKS.FACEBOOK"
          target="_blank"
          class="wk-icon-filled-facebook" />
        <a
          id="twitter"
          :href="FOOTER_LINKS.TWITTER"
          target="_blank"
          class="wk-icon-filled-twitter" />
        <a
          id="linkedin"
          :href="FOOTER_LINKS.LINKEDIN"
          target="_blank"
          class="wk-icon-filled-linkedin" />
        <a
          id="youtube"
          :href="FOOTER_LINKS.YOUTUBE"
          target="_blank"
          class="wk-icon-filled-youtube" />
      </div>
    </div>
    <div
      id="tier2"
      class="tiers">
      <a
        id="contactUs"
        :href="FOOTER_LINKS.CONTACT"
        target="_blank">Contact Us</a>
      <a
        id="aboutUs"
        :href="FOOTER_LINKS.ABOUT"
        target="_blank">About Us</a>
      <a
        id="UTDNews"
        :href="FOOTER_LINKS.UTD_NEWS"
        target="_blank">UpToDate News</a>
    </div>
    <div
      id="tier3"
      class="tiers">
      <a
        id="WKHealth"
        :href="FOOTER_LINKS.WK_HEALTH"
        target="_blank">Wolters Kluwer Health</a>
      <a
        id="emmi"
        :href="FOOTER_LINKS.EMMI"
        target="_blank">Emmi®</a>
      <a
        id="factsComparisons"
        :href="FOOTER_LINKS.FACTS_AND_COMPARISONS"
        target="_blank">Facts &amp; Comparisons®</a>
      <a
        id="lexi"
        :href="FOOTER_LINKS.LEXI"
        target="_blank">Lexicomp®</a>
      <a
        id="medi"
        :href="FOOTER_LINKS.MEDI"
        target="_blank">Medi-Span®</a>
    </div>
  </footer>
</template>

<script>
import Cookies from 'js-cookie';
import { mapActions, mapGetters } from 'vuex';
import ConsoleButton from './ConsoleButton.vue';
import { 
    FOOTER_LINKS,
    MODAL_MESSAGE
} from './constants.js';

export default {
    components: { ConsoleButton },
    data() {
        return {
            FOOTER_LINKS
        };
    },
    computed: {
        ...mapGetters([
            'isAuthenticated',
            'loggedIn'
        ]),

        showSupportTag() {
            if(this.$route.name === 'manage') {
                return Cookies.get('loggedIn') || this.loggedIn;
            }
            else {
                return false;
            }
        }
    },
    methods: {
        ...mapActions([
            'showModal'
        ]),
        onClick() {
            this.showModal(MODAL_MESSAGE.SUPPORT_TAG());
        }
    }
};
</script>

<style lang="scss">
    html,body {
        height: 100%;
    }

    body {
        position: relative;
        margin: 0;
    }

    .footer {
        display: flex;
        flex-direction: column;
        border-top: 1px solid $FOOTER-BORDER-COL;
        background-color: $FOOTER-COL-BGCLR;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
    }

    .copyright {
        display: inherit;
        justify-content: space-between;
        height: 39px;
        margin: 0 56px 0 56px;
    }

    .wkLogo {
        display: inherit;
        background: url('data:image/png;base64,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') no-repeat 50% 0;
        background-position: 0 8px;
        background-size: 150px 34px;
        height: 100%;
        width: 150px;
    }

    .copyrightFull {
        display: inherit;
        line-height: 48px;
        overflow: hidden;
        font-size: 9.6px;
        color: $FOOTER-COPYRIGHT-TEXT-COL;
    }

    .tiers {
        display: inherit;
        align-items: center;
        height: 34px;
        border-top: 1px solid $FOOTER-BORDER-COL;
        padding: 0 56px 0 56px;
        font-size: 10.8px;
        & a {
            color: $FOOTER-TEXT-COL2;
            text-decoration: none;
        }
        & a:hover {
            text-decoration: underline;
        }
    }

    #tier1 {
        height: 38.115px;
        justify-content: space-between;
        & div {
            display: inherit;
            align-items: center;
            gap: 24px;
        }
        & .socials {
            gap: 17px;
            padding-right: 14px;
            & a {
                width: 24px;
                height: 14px;
                font-size: 16px;
                line-height: 14px;
                background: $FOOTER-SOCIALS-COL-BGCLR;
                border-radius: 100px;
                box-shadow: inset 0 0 4px $FOOTER-SOCIALS-COL2-BGCLR;
                color: $FOOTER-SOCIALS-TEXT-COL;
                padding: 5px 0;
            }
        }
        & a {
            color: $FOOTER-TEXT-COL;
            &#ot-sdk-btn.ot-sdk-show-settings {
                  color: $FOOTER-TEXT-COL !important;
                  font-size: 10.8px;
                  line-height: normal;
                  border: none !important;
                  padding: 0px;
                  &:hover {
                    background: none !important;
                    cursor: pointer;
                  }
            }
        }
        & button {
            background: none;
            color: $FOOTER-TEXT-COL;
            font-size: 10.8px;
            border: none;
            padding: 0;
        }
        & button:hover {
            text-decoration: underline;
            cursor: pointer;
        }
    }

    #tier2 {
        gap: 26px;
        & a {
            font-weight: 700;
        }
    }

    #tier3 {
        gap: 27px;
    }
</style>